


























import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';

import { AdminMenuData, Chapter, FeatureSwitches, User } from 'frontend/types';
import { AdminMenuNoun, populateAdminMenu } from 'frontend/utils/admin';
import CreateLessonModal from 'frontend/views/courses/components/CreateLessonModal.vue';
import AdminMenu from 'frontend/components/AdminMenu.vue';
import GoogleClassroomButton from 'frontend/views/courses/components/GoogleClassroomButton.vue';
import { googleClassroomSetup } from 'frontend/views/courses/CoursePage/utils/googleClassroomSetup';

@Component({
  components: { AdminMenu, CreateLessonModal, GoogleClassroomButton },
  computed: {
    ...mapState('globals', ['user']),
    ...mapGetters('globals', ['featureSwitches']),
    ...mapGetters('response', ['baseUrl']),
  },
})
export default class ChapterAdmin extends Vue {
  @Prop({ type: Object, required: true })
  private chapter!: Chapter;
  @Prop({ type: String, required: true })
  private courseVersionName!: string;

  private readonly user!: User;
  private readonly featureSwitches!: FeatureSwitches;
  private readonly baseUrl!: string;

  private isCreateLessonModalOpen: boolean = false;
  private isGoogleClassroomsReadyToRender: boolean = false;

  private get adminMenu(): AdminMenuData | null {
    const chapterNoun: AdminMenuNoun =
      this.courseVersionName === '' ? 'chapter' : 'versioned_chapter';

    return populateAdminMenu(this.chapter, chapterNoun);
  }

  private get shouldShowGoogleClassroomButton(): boolean {
    return (
      this.user.is_classroom_teacher &&
      !!this.featureSwitches.enable_google_classrooms &&
      !!this.chapter.quizzes.length
    );
  }

  private mounted(): void {
    if (this.shouldShowGoogleClassroomButton) {
      googleClassroomSetup.loadScript(() => (this.isGoogleClassroomsReadyToRender = true));
    }
  }
}
